/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdDialogCardProps, TdDialogProps } from './type';

export const dialogCardDefaultProps: TdDialogCardProps = {
  closeBtn: true,
  footer: true,
  header: true,
  theme: 'default',
};

export const dialogDefaultProps: TdDialogProps = {
  closeOnEscKeydown: undefined,
  closeOnOverlayClick: undefined,
  destroyOnClose: false,
  draggable: false,
  mode: 'modal',
  placement: 'top',
  preventScrollThrough: true,
  showInAttachedElement: false,
  showOverlay: true,
  lazy: true,
};
